
import { Order } from '../../../ts/helpers/Order';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { filterToContentTypes } from '../../../ts/ServerApi/types/IContent';
import { IOrderClause } from '../../../ts/ServerApi/types/IOrderClause';

export function getContentTypesFromQueryParam(
  queryParam: string,
  defaultValues: ReadonlyArray<ExplorableItemType>,
): ReadonlyArray<ExplorableItemType> {
  if (queryParam === '') {
    return [];
  } else if (queryParam === null || queryParam === undefined) {
    return defaultValues;
  }
  return filterToContentTypes(queryParam.split(','));
}

export function getOrderClausesFromQueryParam(queryParam: string, defaultOrder: IOrderClause[]): IOrderClause[] {
  if (queryParam === '') {
    return [];
  } else if (queryParam === null || queryParam === undefined) {
    return defaultOrder;
  }
  return Order.fromInput(queryParam);
}
